import { useQuery, useQueryCache } from '@pinia/colada';
import { computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { TimeFilter } from '@tallo/utility';

import propertyService from '../services/property.service';

export function getPropertyStatisticsQueryKey(propertyId: string) {
  return ['property', propertyId, 'statistics'];
}

export function usePropertyStatisticsQuery() {
  const route = useRoute();
  const router = useRouter();
  const queryCache = useQueryCache();

  const propertyId = computed(() => route.params.propertyId as string);
  const selectedFilter = computed({
    get: () => (route.query.statsTimeFilter as TimeFilter) || TimeFilter.LAST_30_DAYS,
    set: (value: TimeFilter) => {
      router.replace({
        query: {
          ...route.query,
          statsTimeFilter: value,
        },
      });
    },
  });

  const query = useQuery({
    key: () => getPropertyStatisticsQueryKey(propertyId.value),
    query: () => propertyService.getPropertyStatistics(propertyId.value, selectedFilter.value),
  });

  watch(
    selectedFilter,
    () => {
      queryCache.invalidateQueries({ key: getPropertyStatisticsQueryKey(propertyId.value) });
    },
    {
      immediate: true,
    },
  );

  return {
    ...query,
    selectedFilter,
  };
}
